import { createContext, useContext, ReactNode, useMemo } from 'react';
import { Route } from 'common/types/tech';
import { AppType, detectAppType } from 'common/utils/app-type';
import { getCommonRoutes } from './routes-common';
import { getSupermodelRoutes } from './routes-supermodel';
import { getAttributesRoutes } from './routes-attributes';
import { getVideoAppRoutes } from './routes-video';

const AppTypeContext = createContext<AppType>('advon');

interface Props {
  children: ReactNode;
}

export function AppTypeProvider({ children }: Props) {
  const appType = detectAppType();
  return <AppTypeContext.Provider value={appType}>{children}</AppTypeContext.Provider>;
}

export function useAppType(): AppType {
  return useContext(AppTypeContext);
}

export const getRoutesForAppType = (appType: AppType): Route[] => {
  const commonRoutes = getCommonRoutes();

  if (appType === 'supermodel') {
    return [...commonRoutes, ...getSupermodelRoutes()];
  }

  return [...commonRoutes, ...getAttributesRoutes(), ...getVideoAppRoutes()];
};

export function useAppRoutes(): Route[] {
  const appType = useAppType();
  return useMemo(() => getRoutesForAppType(appType), [appType]);
}
